export default window.location.origin;
